/**
 *
 *
 */

import RiskFactor from './risk-factor';

export default class Velocity extends RiskFactor {
    static getCondition({velocity}) {
        return !!velocity;
    }

    parse({velocity}) {
        this.velocity = velocity;
        if (this.velocity <= 3) {
            this.icon = 'check-s';
            this.className = 'icon-green';
        } else if (this.velocity >= 4 && this.velocity <= 6) {
            this.icon = 'close-s';
            this.className = 'icon-red';
        } else {
            this.icon = 'dash-l';
        }
    }

    getResult() {
        return `${this.velocity} transaction(s) from this customer in the last 24 hours`;
    }
}
